import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { devicesApi, staticDevicesApi } from '@/api/index';
import type { DeviceBody } from '@/api/routes/devices/types';

export const fetchDevices = createAsyncThunk(
  'devices',
  async (params: DeviceBody, thunkAPI) => {
    try {
      const response = await devicesApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchDevicesOverview = createAsyncThunk(
  'devicesOverview',
  async (params: DeviceBody, thunkAPI) => {
    try {
      const response = await devicesApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticDevicesOverview = createAsyncThunk(
  'devicesOverview',
  async (params: DeviceBody, thunkAPI) => {
    try {
      const response = await staticDevicesApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchDevicesMap = createAsyncThunk(
  'devicesMap',
  async (params: DeviceBody, thunkAPI) => {
    try {
      const response = await devicesApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticDevicesMap = createAsyncThunk(
  'devicesMap',
  async (params: DeviceBody, thunkAPI) => {
    try {
      const response = await staticDevicesApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchDevicesTable = createAsyncThunk(
  'devicesTable',
  async (params: DeviceBody, thunkAPI) => {
    try {
      const response = await devicesApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchStaticDevicesTable = createAsyncThunk(
  'devicesTable',
  async (params: DeviceBody, thunkAPI) => {
    try {
      const response = await staticDevicesApi.getAll(params);
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);

export const fetchDevicesGps = createAsyncThunk(
  'devicesMapGps',
  async (params: string [], thunkAPI) => {
    try {
      const response = await devicesApi.getGps(params);
      return response ? response.data : {};
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
